import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { FadeInUp } from 'app/components/Common/Animation/FadeInUp'
import { Rumble } from 'app/components/Icons'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { theme } from 'app/theme'
import { rgba } from 'emotion-rgba'
import { Link } from 'gatsby'
import React, { memo, useContext } from 'react'

import { FooterContext } from './index'

export const Social = memo(function Social() {
  const {
    facebookURL,
    instagramURL,
    languageCode,
    languagePrefix,
    worksPageURL,
  } = useContext(FooterContext) as any

  const worksPageSlug = worksPageURL?.find(
    (t: any) => t?.languages_code?.code === languageCode,
  )?.slug

  const worksPageTitle = worksPageURL?.find(
    (t: any) => t?.languages_code?.code === languageCode,
  )?.title

  const worksRealPageURL = languagePrefix
    ? `/${languagePrefix}/${worksPageSlug}`
    : `/${worksPageSlug}`

  return (
    <Container dial={4} row wrap>
      {worksPageSlug ? (
        <FadeInUp>
          <InternalLink to={worksRealPageURL}>{worksPageTitle}</InternalLink>

          <Rumble />
        </FadeInUp>
      ) : null}

      {facebookURL ? (
        <FadeInUp delay={0.1}>
          <Facebook
            aria-label="Facebook"
            href={facebookURL}
            rel="noreferrer"
            target="_blank"
          >
            Facebook
          </Facebook>
        </FadeInUp>
      ) : null}

      {instagramURL ? (
        <FadeInUp delay={0.2}>
          <Instagram
            aria-label="Instagram"
            href={instagramURL}
            rel="noreferrer"
            target="_blank"
          >
            Instagram
          </Instagram>
        </FadeInUp>
      ) : null}
    </Container>
  )
})

const Container = styled(FlexBox)`
  margin-top: 4.125rem;

  svg {
    width: 0.375rem;
    height: 0.375rem;
    fill: ${({ theme }) => theme.colors.variants.neutralLight5};
    margin: 0 3rem;
  }

  @media (max-width: 1199px) {
    display: block;
    margin-top: 0.625rem;

    svg {
      display: none;
    }
  }
`

const Style = css`
  color: ${theme.colors.variants.neutralLight5};
  font-family: ${theme.fontFamily.heading};
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.25rem;
  padding-bottom: 0.4375rem;
  position: relative;
  &:hover {
    &:after {
      right: 0;
    }
  }
  &:before,
  &:after {
    content: '';
    height: 0.0625rem;
    position: absolute;
    bottom: 0;
    left: 0;
    transition: 0.3s ease-in-out;
  }
  &:before {
    background: ${rgba(theme.colors.variants.neutralLight5, 0.2)};
    right: 0;
  }
  &:after {
    background: ${theme.colors.variants.neutralLight5};
    right: 100%;
  }

  @media (max-width: 1199px) {
    display: inline-block;
    font-size: 0.875rem;
    line-height: 1.125rem;
    margin-top: 1.25rem;
  }
`

const InternalLink = styled(Link)`
  ${Style}
`

const Facebook = styled.a`
  ${Style}
`

const Instagram = styled.a`
  ${Style}

  margin-left: 1.5rem;

  @media (max-width: 1199px) {
    margin-left: auto;
  }
`
